class BackInStockButton extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.back-in-stock__trigger');
    this.modal = this.querySelector('.back-in-stock__modal');
    this.closeBtn = this.querySelector('.back-in-stock__close');
    this.form = this.querySelector('.back-in-stock__form');
    this.input = this.querySelector('.back-in-stock__input');
    this.submit = this.querySelector('.back-in-stock__submit');
    this.success = this.querySelector('.back-in-stock__success');
    this.companyId = window.KLAVIYO_PUBLIC_KEY;
  }

  connectedCallback() {
    this.trigger.addEventListener('click', () => this.openModal());
    this.closeBtn.addEventListener('click', () => this.closeModal());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    this.observeAddButton();
  }

  observeAddButton() {
    let attempts = 0;
    const wait = setInterval(() => {
      const addBtn = document.querySelector('button[name="add"]');
      attempts++;
      if (addBtn || attempts > 20) {
        clearInterval(wait);
        if (addBtn) {
          this.sync(addBtn);
          new MutationObserver(() => this.sync(addBtn)).observe(addBtn, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class']
          });
        }
      }
    }, 200);
  }

  sync(addBtn) {
    const isUnavailable = addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true';
    this.style.display = isUnavailable ? 'block' : 'none';
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');
    if (variantId) this.dataset.variantId = variantId;
  }

  openModal() {
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.input.focus(), 100);
  }

  closeModal() {
    this.modal.hidden = true;
    document.body.style.overflow = '';
    this.success.hidden = true;
    this.submit.disabled = false;
    this.input.value = '';
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.companyId) return;
    this.submit.disabled = true;
    const email = this.input.value;
    const variantId = this.dataset.variantId;

    fetch(
      'https://a.klaviyo.com/api/back-in-stock-subscriptions/?company_id=' + this.companyId,
      {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'revision': '2024-10-15',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId
                }
              }
            }
          }
        })
      }
    ).catch(() => {});

    setTimeout(() => {
      this.success.hidden = false;
      this.input.value = '';
      setTimeout(() => this.closeModal(), 2500);
    }, 600);
  }
}

customElements.define('back-in-stock-button', BackInStockButton);